export default (palette, isDarkMode) => ({
  root: {
    borderRadius: '8px',
    backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.03)' : 'rgba(0, 0, 0, 0.02)',
    '&:hover:not($disabled) $notchedOutline': {
      borderColor: isDarkMode ? 'rgba(255, 255, 255, 0.4)' : 'rgba(0, 0, 0, 0.3)',
    },
    '&$focused $notchedOutline': {
      borderColor: palette.primary.main,
      borderWidth: '2px',
    },
  },
  notchedOutline: {
    borderColor: isDarkMode ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.15)',
    transition: 'border-color 0.2s cubic-bezier(0.4, 0, 0.2, 1), border-width 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
  },
})
